import apiConfig from "../../../utils/instance/apiConfig";

export const sendPayu = async (formData) => {
  try {
    const response = await apiConfig.post("/payu/pagos", formData);
    return response.data;
  } catch (error) {
    throw new Error("Error al procesar el pago con PayU");
  }
};

export const getMercadoPago = async (formData) => {
  try {
    const response = await apiConfig.post("/mercadopago/pagos", formData);
    return response.data;
  } catch (error) {
    throw new Error("Error al procesar el pago con MercadoPago");
  }
};

export const getPaymentInfo = async (codigo) => {
  try {
    const response = await apiConfig.post("/users/payments", { codigo });
    return response.data;
  } catch (error) {
    throw new Error("Error fetching payment data");
  }
};
